var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-field',{ref:"select",attrs:{"id":_vm.id,"disabled":_vm.loading,"name":_vm.name,"empty-option":true,"items":_vm.categories}})
}
var staticRenderFns = []

export { render, staticRenderFns }